import { saveClicked, loadVisited } from './links.js'

const scriptSelector = '#com_arukikata'
const targetSelector = '.cs-step_map'

const html = `
<div class="cs-step_map-inner">
  <h2 class="cs-heading chara rc_01"><span>「kintoneの歩き方」を読んで<br class="_sp">キントーンをもっと便利に活用しよう！</span></h2>
  <ul class="css-list">
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/arukikata/arukikata-vol01-thumb.png" srcset="../assets/images/arukikata/arukikata-vol01-thumb@2x.png 2x" alt="Vol.1 サポート活用上手はkintone活用上手!?"></div>
      <div class="data">
        <h3 class="title"><span class="vol01">Vol.1</span>サポート活用上手はkintone活用上手!?</h3>
        <ul class="link_list vol01">
          <li><a href="../pages/01-01.html">kintoneをオリジナルデザインにしよう！</a></li>
          <li><a href="../pages/01-02.html">チームにログイン方法をお知らせしよう！</a></li>
          <li><a href="../pages/01-02_2.html">kintoneモバイルアプリをインストールしよう！</a></li>
          <li><a href="../pages/01-03.html">手元のエクセルをアプリにしよう！</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/support/menu/" target="_blank">サポート活用上手はkintone活用上手</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga01.html" target="_blank">まんが「先輩はムチャブリがお好き！？」</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga11.html" target="_blank">まんが「きとみのドタバタ伝道師ダイアリー」</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/about_us/" target="_blank">サイボウズってどんな会社？</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_nihonbashi.pdf" target="_blank">オフィス周辺マップ 日本橋編</a></li>
        </ul>
      </div>
    </li>
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/arukikata/arukikata-vol02-thumb.png" srcset="../assets/images/arukikata/arukikata-vol02-thumb@2x.png 2x" alt="Vol.2 チームのみんなに使ってもらおう！"></div>
      <div class="data">
        <h3 class="title"><span class="vol02">Vol.2</span>チームのみんなに使ってもらおう！</h3>
        <ul class="link_list vol02">
          <li><a href="../pages/02-01.html">ちょっとの工夫ですっごく変わる</a></li>
          <li><a href="../pages/02-02.html">成功したセンパイに学ぶ しくじらない社内浸透のコツ</a></li>
          <li><a href="../pages/02-03.html">社内浸透のきっかけになるキラーアプリを作ろう</a></li>
          <li><a href="../pages/02-04.html">現場の要望をkintoneで上手にすいあげよう！</a></li>
          <li><a href="../pages/02-05.html">kintoneをもっと便利に使おう！</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/KW-vol2-5_2.pdf" target="_blank">たったひとつの大切なこと</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga03.html" target="_blank">まんが「BARA☆BARAフォーマット」</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_matsuyama.pdf" target="_blank">オフィス周辺マップ 松山編</a></li>
        </ul>
      </div>
    </li>
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/arukikata/arukikata-vol03-thumb.png" srcset="../assets/images/arukikata/arukikata-vol03-thumb@2x.png 2x" alt="Vol.3 業務まるごと見える化！"></div>
      <div class="data">
        <h3 class="title"><span class="vol03">Vol.3</span>業務まるごと見える化！</h3>
        <ul class="link_list vol03">
          <li><a href="../pages/03-01.html">業務まるごと見える化</a></li>
          <li><a href="../pages/03-02.html">見せられないデータが増えたらアクセス権を使おう</a></li>
          <li><a href="../pages/03-03.html">メールやチャットが原因のざんねんな情報共有</a></li>
          <li><a href="../pages/03-04.html">検索の達人</a></li>
          <li><a href="../pages/03-05.html">私はこの機能でストレスフリーになりました</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/KW-vol3-6.pdf" target="_blank">オンラインユーザーコミュニティ「キンコミ」</a></li>
          <li><a href="../pages/03-07.html">印刷をかんたんに美しく</a></li>
          <li><a href="../pages/03-08.html">プラグイン・連携サービス・カスタマイズ機能を使う方法</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga04.html" target="_blank">まんが「部長を探せ！パニック☆大捜索」</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_osaka.pdf" target="_blank">オフィス周辺マップ 大阪編</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_nagoya.pdf" target="_blank">オフィス周辺マップ 名古屋編</a></li>
        </ul>
      </div>
    </li>
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/arukikata/arukikata-vol04-thumb.png" srcset="../assets/images/arukikata/arukikata-vol04-thumb@2x.png 2x" alt="Vol.4 つながる！ひろがる！"></div>
      <div class="data">
        <h3 class="title"><span class="vol04">Vol.4</span>つながる！ひろがる！</h3>
        <ul class="link_list vol04">
          <li><a href="../pages/04-01.html">アプリをみんなで作れるようにするとどんどん広がる</a></li>
          <li><a href="../pages/04-02.html">褒められアプリの作り方</a></li>
          <li><a href="../pages/04-03.html">ちょっと待って！そのお悩み、基本機能で解決できます！</a></li>
          <li><a href="../pages/04-04.html">つながる広がるkintoneの世界</a></li>
          <li><a href="../pages/04-05.html">よくわかるkintoneカスタマイズ</a></li>
          <li><a href="../pages/04-05_2.html">kintoneカスタマイズを実施する前に！気がかりQ&A</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga08.html" target="_blank">まんが「ビッグプロジェクトはわがままな香り」</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_sendai.pdf" target="_blank">オフィス周辺マップ 仙台編</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_fukuoka.pdf" target="_blank">オフィス周辺マップ 福岡編</a></li>
        </ul>
      </div>
    </li>
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/arukikata/arukikata-vol05-thumb.png" srcset="../assets/images/arukikata/arukikata-vol05-thumb@2x.png 2x" alt="Vol.5 メンバーの入れ替えに備えて"></div>
      <div class="data">
        <h3 class="title"><span class="vol05">Vol.5</span>メンバーの入れ替えに備えて</h3>
        <ul class="link_list vol05">
          <li><a class="pdf" href="/material/pdf/support/arukikata/KW-vol5-1.pdf" target="_blank">kintoneのセンパイ10人にクローズアップ</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/KW-vol5-2.pdf" target="_blank">センパイQ&Aお悩み相談室</a></li>
          <li><a href="../pages/05-03.html">kintoneを使いこなすための道のりカレンダー</a></li>
          <li><a href="../pages/05-04.html">kintoneを好きになってもらう16のコツ</a></li>
          <li><a href="../pages/05-04_2.html">新任管理者への引き継ぎ方</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/KW-vol5-5.pdf" target="_blank">ユーザーズライブイベント「kintone hive」</a></li>
          <li><a href="../pages/05-06.html">サイボウズ社内 スペースBEST3</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/jp/kitomi/manga/manga12.html" target="_blank">まんが「恋も仕事もホップステップ♪」</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/senpai_message.pdf" target="_blank"><span class="_pc">kintone</span>管理者さまへのセンパイからのメッセージ</a></li>
          <li><a class="pdf" href="/material/pdf/support/arukikata/office_sfo.pdf" target="_blank">オフィス周辺マップ サンフランシスコ編</a></li>
        </ul>
      </div>
    </li>
    <li class="css-item">
      <div class="thumb"><img src="../assets/images/module/thumb-extra.svg" alt="EX スペシャルコンテンツ"></div>
      <div class="data">
        <h3 class="title"><span class="extra">EX</span>スペシャルコンテンツ</h3>
        <ul class="link_list extra">
          <li><a href="../kintone-startguide-seminar/">kintone スタートガイドセミナー</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/myrecipe/" target="_blank">"kintone"って結局何ができるの？</a></li>
          <li><a href="../kokoroe/">kintoneアプリ作成の心得</a></li>
          <li><a href="../hiyarihat/">kintoneヒヤリハットクイズ</a></li>
          <li><a class="site" href="https://kintone.cybozu.co.jp/support/navi/" target="_blank">お悩み相談ナビ</a></li>
        </ul>
      </div>
    </li>
  </ul>
  <p class="css-text">実際に手に取ってお楽しみ頂きたい方は､<br class="_sp">フォームより冊子をご請求ください。</p>
  <div class="css-link"><a href="https://kintone.form.kintoneapp.com/public/ce34d58a0a673a3603988adabf49d416d74b5de1204913f702739eaa42a781ae?%E3%83%81%E3%82%A7%E3%83%83%E3%82%AF%E3%83%9C%E3%83%83%E3%82%AF%E3%82%B9=%E6%B4%BB%E7%94%A8%26%E6%B5%B8%E9%80%8F%E3%81%AE%E3%82%B9%E3%83%86%E3%83%83%E3%83%97%E3%80%8Ckintone%E3%81%AE%E6%AD%A9%E3%81%8D%E6%96%B9%E3%80%8Dvol.1,%E6%B4%BB%E7%94%A8%26%E6%B5%B8%E9%80%8F%E3%81%AE%E3%82%B9%E3%83%86%E3%83%83%E3%83%97%E3%80%8Ckintone%E3%81%AE%E6%AD%A9%E3%81%8D%E6%96%B9%E3%80%8Dvol.2,%E6%B4%BB%E7%94%A8%26%E6%B5%B8%E9%80%8F%E3%81%AE%E3%82%B9%E3%83%86%E3%83%83%E3%83%97%E3%80%8Ckintone%E3%81%AE%E6%AD%A9%E3%81%8D%E6%96%B9%E3%80%8Dvol.3,%E6%B4%BB%E7%94%A8%26%E6%B5%B8%E9%80%8F%E3%81%AE%E3%82%B9%E3%83%86%E3%83%83%E3%83%97%E3%80%8Ckintone%E3%81%AE%E6%AD%A9%E3%81%8D%E6%96%B9%E3%80%8Dvol.4,%E6%B4%BB%E7%94%A8%26%E6%B5%B8%E9%80%8F%E3%81%AE%E3%82%B9%E3%83%86%E3%83%83%E3%83%97%E3%80%8Ckintone%E3%81%AE%E6%AD%A9%E3%81%8D%E6%96%B9%E3%80%8Dvol.5" target="_blank">資料請求フォーム</a></div>
</div>

`

document.addEventListener('DOMContentLoaded', () => {
  const targetElm = document.querySelector(targetSelector)
  targetElm.insertAdjacentHTML('beforeend', html)

  saveClicked()
  loadVisited()
})
